import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { UnifiedAccServiceComponent } from './UnifiedAccServiceComponent';
export const UnifiedAccReconnectionConfig = {
  serviceComponent: UnifiedAccServiceComponent,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.CONNECTION_LOST]
};